var indentation_default = {
  "indentZero": "Xs6GJ",
  "indentOne": "FLbPY",
  "indentTwo": "KW4A2",
  "indentThree": "_27dDa",
  "indentFour": "-wNJ8",
  "indentFive": "OVJhM",
  "indentSix": "YKcMa"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
